module.exports = __webpack_public_path__ + "img/growth.86adb56.svg";